import React, { useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, GradeProduto, InputsRefs, KEY_CODE_ENTER, MovimentacaoProduto, Produto, classBorderLabelDark, classBt, classDivBackground, classDivBody,
    classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classbtAzul, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul
} from '../../Utils/Types'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { IoCameraOutline, IoPrint, IoSearch, IoSearchOutline } from 'react-icons/io5'
import { ProdutoService } from '../Products/ProdutoService'
import { AcertoEstoqueService } from './AcertoEstoqueService'
import { GridEmpty } from '../../Components/GridEmpty/grid-empty'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'
import { MovimentacaoPDF } from './pdf/movimentacao-pdf'
import { AiOutlineClear } from 'react-icons/ai'
import { FaPeopleCarryBox } from 'react-icons/fa6'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'
import { FaVideo } from 'react-icons/fa'


export const MovimentacaoEstoque = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .add(-31, 'days')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    const [loading, setLoading] = useState(false)
    const [loadingPesq, setLoadingPesq] = useState(false)

    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [produtosList, setProdutosList] = useState<Produto[]>([])
    const [gradeList, setGradeList] = useState<GradeProduto[]>([])

    const [idProdSelecionado, setIdProdSelecionado] = useState(0)
    const [descProd, setDescProd] = useState("")
    //const [descProdCopy, setDescProdCopy] = useState("")
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [idGrade, setIdGrade] = useState("")
    const [descVariacaoGrade, setDescVariacaoGrade] = useState("")
    const [descSubVariacaoGrade, setDescSubVariacaoGrade] = useState("")

    const [movimentacoes, setMovimentacoes] = useState<MovimentacaoProduto[]>([])
    const [totEnt, setTotEnt] = useState<number>(0)
    const [totSai, setTotSai] = useState<number>(0)
    const [tableHeight, setTableHeight] = useState<number>()
    const [isGrade, setIsGrade] = useState(false)

    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    // ---------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------
    const handleDataiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleDatafChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeDescProd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescProd(e.target.value)
        setProdutosList([])
        setIdProdSelecionado(0)
        //setDescProdCopy('')
        setLinhaSelecionada(-1)
    }

    // ------------------------------------------------------------------------- USE-EFFECT ------------------------------------------------------------------------------------
    useEffect(() => {
        Inputfocus()
    }, [])

    /*
    useEffect(() => {

        setProdutosList([])

        if (descProdCopy === '') {

            const delayDebounceFn = setTimeout(() => {

                if (descProd && descProd.length > 0) {

                    ProdutosFilter()  // Chama a função após 500 segundos de inatividade
                } else {

                    setProdutosList([])
                }
            }, 500) // 500 segundos

            setIdProdSelecionado(0)

            return () => clearTimeout(delayDebounceFn)

        } else {

            setDescProdCopy("")
            setLinhaSelecionada(-1)
        }
        
        if (descProdCopy === '') {

            if (descProd.trim().length > 0 && (descProd.trim().length % 4) === 0) {
                ProdutosFilter()
            } else if (descProd.trim().length == - 0) {
                setProdutosList([])
            }
        } else {
            setDescProdCopy("")
        }  

    }, [descProd])
    */

    useEffect(() => {

        const inputElement = document.getElementById("pesquisa")

        if (descProd === "") {
            setGradeList([])
            setIdGrade("")
        }

        const handleKeyDown = (event: any) => {

            const { key } = event

            if (key === 'ArrowUp' || key === 'ArrowDown') {

                event.preventDefault()

                let nextIndex
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionada === -1 || linhaSelecionada === 0 ? produtosList.length - 1 : linhaSelecionada - 1;
                } else {
                    nextIndex = linhaSelecionada < produtosList.length - 1 ? linhaSelecionada + 1 : 0;
                }

                const selectedItem = produtosList[nextIndex]

                if (selectedItem != undefined) {

                    handleSetProdMove(selectedItem, nextIndex)
                    setLinhaSelecionada(Math.max(0, Math.min(nextIndex, produtosList.length - 1)))

                    console.log("selectedItem: ", selectedItem)

                    // Scroll into view
                    const element = document.getElementById(`produto-grade-${nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                } else {
                    setLinhaSelecionada(-1)
                    //setProdutosList([])
                }
            }
        }

        const handleKeyPressEnter = async (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && document.activeElement === inputElement && !loadingPesq) {

                if (produtosList.length > 0 && linhaSelecionada !== -1) {

                    //setDescProd(descProdCopy)

                    setProdutosList([])
                    setLinhaSelecionada(-1)


                    setLoadingPesq(true)
                    setGradeList(await ProdutoService.GetGradeProduto(idProdSelecionado.toString()))
                    setLoadingPesq(false)

                    Inputfocus()
                } else {
                    ProdutosFilter()
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [linhaSelecionada, produtosList, descProd, loadingPesq])

    // ------------------------------------------------------------------------- FILTROS ---------------------------------------------------------------------------------------
    const ProdutosFilter = async () => {

        setLoadingPesq(true)
        setVisible(false)
        setProdutosList([])

        try {

            const relatorio = {
                status: 'S',
            }

            const produtos = await ProdutoService.Filter('descricao', descProd, 'start', relatorio)
            setProdutosList(produtos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar os produtos')

        } finally {
            setLoadingPesq(false)

            const timer = setTimeout(() => {

                const inputElement = document.getElementById("pesquisa")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleSelectGrade = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setIdGrade(e.target.value)

        const grade = gradeList.find(g => g.id?.toString() === e.target.value);
        setDescVariacaoGrade(grade?.variacao.description || '')
        setDescSubVariacaoGrade(grade?.subVariacao?.description || '')

    }

    const handleSetProdClick = async (item: any, index: number) => {

        console.log('item:  ', item)

        setIsGrade(item.isGrade)
        setIdProdSelecionado(item.id)
        setLoadingPesq(true)
        setGradeList(await ProdutoService.GetGradeProduto(item.id))
        setLoadingPesq(false)
        setDescProd(item.descricao)
        setProdutosList([])
        setLinhaSelecionada(-1)
    }

    const handleSetProdMove = (item: any, index: number) => {
        setIsGrade(item.isGrade)
        setIdProdSelecionado(item.id)
        setDescProd(item.descricao)
        //setDescProdCopy(item.descricao)
        setLinhaSelecionada(index)
    }

    const handleClearFields = () => {
        setDescProd("")
        setIdProdSelecionado(0)
        //setDescProdCopy("")
        setDatai(dateI)
        setDataf(dateF)
        setMovimentacoes([])
        setTotEnt(0)
        setTotSai(0)
        Inputfocus()
        setVisible(false)
        setLinhaSelecionada(-1)
        fecharListaProduto()
    }

    const fecharListaProduto = () => {

        setProdutosList([])
        //setIdProdSelecionado(0)
        //setDescProdCopy('')
        setLinhaSelecionada(-1)

    }

    // ------------------------------------------------------------------------- API E IMPRESSÃO -------------------------------------------------------------------------------
    const handleMovimentacaoClick = async () => {


        if (isGrade && idGrade === "") {
            setVisible(true)
            setMessageType('DANGER')
            setMessage("Favor selecionar uma grade")
            return
        }

        setVisible(false)
        Inputfocus()
        setLoading(true)
        setMovimentacoes([])
        setTotEnt(0)
        setTotSai(0)
        fecharListaProduto()

        try {

            const retAPI = await AcertoEstoqueService.FiltrarMovimentacao(datai, dataf, idProdSelecionado, idGrade)

            if (retAPI.error) {
                setVisible(true)
                setMessageType('DANGER')
                setMessage(retAPI.msg || "")
                setMovimentacoes([])
                return
            }

            let movs = retAPI.data

            setTotEnt(movs.totEntrada)
            setTotSai(movs.totSaida)

            setMovimentacoes(movs.movimentacao)

            let divTitle = document.getElementById('div-title') as HTMLDivElement
            let divHeader = document.getElementById('div-header') as HTMLDivElement
            //let divDados = document.getElementById('div-dados') as HTMLDivElement
            let divAuditoria = document.getElementById('div-auditoria') as HTMLDivElement

            const height = window.innerHeight - divTitle.clientHeight - divHeader.clientHeight - divAuditoria.clientHeight - 170
            setTableHeight(height)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar as movimentações de estoque desse produto')

        } finally {
            setLoading(false)
        }
    }

    const handlePrint = () => {
        const movimentacaoPDF = new MovimentacaoPDF(movimentacoes, descProd, descVariacaoGrade, descSubVariacaoGrade, datai, dataf, totEnt, totSai)
        movimentacaoPDF.GerarPDF(movimentacoes)

        Inputfocus()
    }


    // ------------------------------------------------------------------------- FUNÇÕES DE FOCUS E MENSAGEM -------------------------------------------------------------------
    const handleCloseMessage = () => {
        setVisible(false)
        //setMessage("")
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("data-inicial")
        inputElement?.focus()
    }

    // ---------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        datai: useRef(null),
        dataf: useRef(null),
        descProd: useRef(null),
        grade: useRef(null),
    }

    const handleTabPress = async (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 0 && idProdSelecionado > 0 && isGrade && gradeList.length === 0) {
                setLoadingPesq(true)
                setGradeList(await ProdutoService.GetGradeProduto(idProdSelecionado.toString()))
                setLoadingPesq(false)
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }


    // ------------------------------------------------------------------------- FUNÇÕES SEM USO -------------------------------------------------------------------------------
    const handleFilterProd = () => {
        //setProdutosList([])
        //if (descProd.trim().length > 0) {
        // ProdutosFilter()
        //}
    }

    /* 
    onKeyDown={(event) => event.keyCode === 13 ? handleFilterProd() : null} 
    const handleKeyPressEnter = async (e: any) => {
        if (e.code === "Enter" || e.code === "NumpadEnter") {
            await ProdutosFilter()
        }
    }
    
    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [datai, dataf, descProd])
    */

    const handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        //const target = e.target as HTMLElement
        //if (target instanceof HTMLAnchorElement) {
        //target.blur()
        //}

        //Inputfocus()
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`} >

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div id='div-title' className={`${classDivTitulo} flex flex-row mb-2`}>

                        <div className={`flex items-center w-full`}>
                            <FaPeopleCarryBox className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}> Movimentações De Estoque</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} max-w-[150px] h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                    </div>

                    <div id='div-header' className={`w-full h-auto grid grid-cols-12 gap-3 items-center rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 cursor-default px-4 py-5`}>

                        <div className={`relative col-span-12 md:col-span-6 xl:col-span-3 2xl:col-span-2 mt-2`}>
                            <input ref={inputsRefs.datai} onKeyDown={(e) => handleTabPress(e, 'datai')} id='data-inicial' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} onFocus={fecharListaProduto} onChange={handleDataiChange} />
                            <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Inicial do saldo</label>
                        </div>

                        <div className={`relative col-span-12 md:col-span-6 xl:col-span-3 2xl:col-span-2 mt-2`}>
                            <input ref={inputsRefs.dataf} onKeyDown={(e) => handleTabPress(e, 'dataf')} id='data-final' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} onFocus={fecharListaProduto} onChange={handleDatafChange} />
                            <label htmlFor="data-final" className={`${classLabel} ${classLabelDark}  ${classBorderLabelDark}`}>Data Final do saldo</label>
                        </div>

                        <div className={`relative col-span-12 xl:col-span-6 2xl:col-span-5 mt-2`}>

                            <input ref={inputsRefs.descProd} onKeyDown={(e) => handleTabPress(e, 'descProd')} id='pesquisa' className={`${classInput} ${classInputDark} pr-14`} placeholder='Digite o nome do produto e pressione Enter ou clique na lupa para buscar o produto' autoComplete='off' value={descProd} disabled={loadingPesq} onChange={handleChangeDescProd} />
                            <label htmlFor="pesquisa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Produto</label>

                            <button className={`absolute h-[43px] w-10 right-[1px] z-10 border bg-slate-300 hover:bg-slate-600 transition-colors duration-300 mt-[1px]
                                        border-slate-400 border-y-0 border-r-0 dark:bg-slate-500 dark:hover:bg-slate-800 dark:border-slate-700 dark:focus:border-slate-400" rounded-r-md `} onClick={ProdutosFilter}>
                                <div className={`w-full h-full flex justify-center items-center text-slate-700 hover:text-slate-300 dark:text-slate-100`}>
                                    {!loadingPesq &&
                                        <IoSearch className={`h-[18px] w-[18px]`} />
                                    }
                                    {loadingPesq &&

                                        <div className={`z-10 absolute mx-2 inline-block h-[18px] w-[18px] animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    }
                                </div>
                            </button>

                            <div className={`relative w-full`}>
                                {produtosList.length > 0 &&

                                    <div className={`absolute z-20 w-full min-h-[100px] max-h-[600px] overflow-y-auto bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-800 rounded-md`}>

                                        <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                            <ul id='elementos' className={`w-full`}>

                                                {produtosList.map((item, index) => {
                                                    return (

                                                        <li key={item.id} id={`produto-grade-${index}`} onClick={() => handleSetProdClick(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                            <div className={`w-full flex flex-row h-[48px] font-mono border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>

                                                                <div className={`flex items-center w-[10%] break-all`}>
                                                                    {item.urlImage &&
                                                                        <img alt='' className={`w-12 h-10 mx-1 bg-white`} src={item.urlImage} />
                                                                    }
                                                                    {!item.urlImage &&
                                                                        <IoCameraOutline className={`w-12 h-10 mx-1 text-slate-300`} />
                                                                    }
                                                                </div>

                                                                <div className={`flex items-center text-sm w-[60%] break-all`}>
                                                                    <span className={`px-2`}>{item.descricao.trim()}</span>
                                                                </div>

                                                                <div className={`flex flex-row text-sm w-[30%] px-2`}>
                                                                    <span className={`px-2 flex items-center justify-start w-full`}>Estq. Fís.: </span> <span className={`flex items-center justify-end w-auto`}>{item.estoque_fisico}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    )
                                                })}

                                            </ul>

                                        </div>

                                    </div>
                                }
                            </div>
                        </div>

                        <div className={`relative col-span-12 xl:col-span-6 2xl:col-span-3 mt-2`}>
                            <select ref={inputsRefs.grade} onKeyDown={(e) => handleTabPress(e, 'grade')} disabled={gradeList.length === 0 || loadingPesq} id='grade' className={`${classInput} ${classInputDark} disabled:opacity-40 disabled:cursor-not-allowed `} value={idGrade} onChange={handleSelectGrade}>
                                <option value=""></option>
                                {gradeList.map((grade) => {
                                    return <option key={grade.id} value={grade.id}>{grade.variacao.description} - {grade.subVariacao?.description}</option>
                                })}
                            </select>
                            <label htmlFor="grade" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Grade de produtos</label>
                        </div>

                        <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-2`}>

                            <div className={`relative mt-2 sm:mt-0`}>

                                <button tabIndex={-1} className={`${classBt} ${classbtCeuAzul} disabled:opacity-50 disabled:cursor-not-allowed w-full sm:min-w-[150px]`} disabled={loading || !(movimentacoes.length > 0)} onClick={handlePrint} >
                                    <IoPrint size="20px" className={`mr-[5px]`} /> Imprimir
                                </button>

                            </div>

                            <div className={`relative mt-6 sm:mt-0`}>

                                <button tabIndex={-1} className={`${classBt} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} disabled={loading} onClick={handleClearFields} >
                                    <AiOutlineClear size="20px" className={`mr-[5px]`} />
                                    <span >Limpar Campos</span>
                                </button>

                            </div>

                            <div className={`relative mt-6 sm:mt-0`}>

                                <button tabIndex={-1} className={`${classbtColunasAzul} w-full sm:min-w-[150px]`} disabled={loading} onClick={handleMovimentacaoClick} >

                                    {loading &&
                                        <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    }
                                    {!loading &&
                                        <IoSearch size="20px" className={`mr-[5px]`} />
                                    }
                                    {!loading && `Filtrar Dados`} {loading && `Aguarde`}

                                </button>

                            </div>

                        </div>

                    </div>

                    <div id='div-dados' className={`flex w-full mt-2`}>

                        {movimentacoes.length === 0 &&
                            <GridEmpty />
                        }

                        {movimentacoes.length > 0 &&
                            <div className={`max-h-[450px] w-full overflow-auto scrollbar-custom dark:scrollbar-custom-dark border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800`}>

                                <div className={`w-full`}>

                                    <div className={`min-w-[1300px] w-full h-auto bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                        <ul className={`w-full h-full`}>

                                            <li className={`h-10`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-full max-w-[150px] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Data</span>
                                                    </div>

                                                    <div className={`flex items-center w-full  h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Histórico</span>
                                                    </div>

                                                    <div className={`flex items-center w-full max-w-[150px] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Tipo</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-full max-w-[200px] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Saldo</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-full max-w-[200px] h-full border border-slate-300  dark:border-slate-700`}>
                                                        <span className={`px-3`}>Acumulado</span>
                                                    </div>

                                                </div>

                                            </li>

                                        </ul>

                                    </div>

                                </div>



                                <div className={`w-full`}>

                                    <div className={`min-w-[1300px] w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                        <ul className={`w-full`}>

                                            {movimentacoes.length > 0 &&
                                                movimentacoes.map((item, index) => {
                                                    return (

                                                        <li key={index} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                            <div className={`w-full flex flex-row h-[50px] font-mono`}>

                                                                <div className={`flex items-center w-full max-w-[150px] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-3`}>{moment(item.dhInsert).format("DD/MM/YYYY")}</span>
                                                                </div>

                                                                <div className={`flex items-center w-full break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-3`}>{item.observacao}</span>
                                                                </div>

                                                                <div className={`flex items-center w-full max-w-[150px] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-3`}>{item.tipo === "E" ? "Entrada" : "Saída"}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-full max-w-[200px] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-3`}>{Funcoes.numberFormat(item.qtd)}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-full max-w-[200px] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-3`}>{Funcoes.numberFormat(item.acumulado)}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    )
                                                })
                                            }

                                        </ul>

                                    </div>

                                </div>




                            </div>
                        }

                    </div>

                    <div id='div-auditoria' className={`w-full h-auto grid grid-cols-12 mt-4 bg-white dark:bg-slate-600 border rounded-md shadow-sm shadow-slate-400 dark:border-slate-800 dark:shadow-slate-800`}>

                        <div className={`col-span-12 md:col-span-3 border border-l-0 border-y-0 border-r-transparent md:border-r-slate-300 dark:border-r-slate-700 my-2 px-2 py-3`}>
                            <span className={`text-base font-bold dark:text-white`}>Auditoria</span>
                        </div>

                        <div className={`col-span-12 md:col-span-3 border border-l-0 border-t-0 border-r-transparent md:border-r-slate-300 dark:border-b-slate-700 md:border-b-0 dark:border-r-slate-700 my-2 px-2 py-3`}>

                            <div className={`w-full flex flex-row`}>
                                <span className={`w-full md:w-auto text-base text-blue-600 dark:text-sky-500 font-bold`}>Entradas: </span>
                                <span className={`w-full md:w-auto text-base text-blue-600 dark:text-sky-500 font-bold flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totEnt)}</span>
                            </div>

                        </div>

                        <div className={`col-span-12 md:col-span-3 border border-l-0 border-t-0 border-r-transparent md:border-r-slate-300 dark:border-b-slate-700 md:border-b-0 dark:border-r-slate-700 my-2 px-2 py-3`}>

                            <div className={`w-full flex flex-row`}>
                                <span className={`w-full md:w-auto text-base text-red-400 font-bold`}>Saídas: </span>
                                <span className={`w-full md:w-auto text-base text-red-400 font-bold flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totSai)}</span>
                            </div>

                        </div>

                        <div className={`col-span-12 md:col-span-3 my-2 px-2 py-3`}>

                            <div className={`w-full flex flex-row`}>
                                <span className={`w-full md:w-auto text-base dark:text-white font-bold`}>Saldo: </span>
                                <span className={`w-full md:w-auto text-base dark:text-white font-bold flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totEnt - totSai)}</span>
                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_movimentacaoEstoque.mp4'
                            title='Como verificar a moviemntação de estoque'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>

    )
}